import React from "react";
import { Link } from "react-router-dom";

import styles from "./NavLink.scss";

function NavLink({ title, path, target }) {
  let content = title;

  if (path) {
    content = (
      <Link to={path} title={title} target={target} className={styles.navLink}>
        {title}
      </Link>
    );
  }

  return <div className={styles.page}>{content}</div>;
}

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/Footer/NavLink/NavLink.tsx